export const CustomerSort = {
    ALPHABETICALLY: "alphabetically",
    DEBTAMOUNT: "debtAmount"
}